module.exports = __webpack_public_path__ + "static/media/step2.0eb3f283.svg";